import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useCallback } from "react";
import * as api from "../../api/index";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Form, FormElement } from "@progress/kendo-react-form";
import DisbursementGrid from "./DisbursementGrid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { TextArea } from "@progress/kendo-react-inputs";
import MattersCombobox from "../Postings/MattersComboBox";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import { toast } from "react-toastify";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import { useNominalsBySubType } from "services/nominalsService";
import { useActiveFeeEarner } from "services/userService";
import { NominalSubtypes } from "components/Enums/Nominals.ts";

const DisbursementPayment = (props) => {
  const date = new Date();
  const formRenderPropsRef = React.useRef(null);
  const [details, setDetails] = useState("");
  const [reference, setReference] = useState("");
  const [payee, setPayee] = useState("");
  const [amount, setAmount] = useState(0);
  const [dateselector, setdateselector] = useState(date);
  const [matterRef, setmatterref] = useState();
  const [data, setData] = useState([]);
  const [allocation, setAllocation] = useState(null);
  const [resetmatter, setresetmatter] = useState(false);
  const [initialData, setInitialData] = useState({
    date: new Date(Date.now()),
  });
  const [loading, setLoading] = useState(false);
  const [validationAttempted, setValidationAttempted] = useState(false);
  const { files: filesCurrentData, clearDisbursementFiles } = useFiles(
    FILES_CONTEXT.DISBURSEMENT_PAYMENT,
  );
  const [filesData, setFilesData] = useState([]);

  const { uploadForm, progress } = useUploadForm();
  const { data: activeFeeEarners = [] } = useActiveFeeEarner();
  const { data: officeBankNominals = [] } =
    useNominalsBySubType(NominalSubtypes.OFFICE_BANK) || [];

  /** Convert money values to cents for exact comparison */
  const toCents = (n) => Math.round((Number(n) || 0) * 100);

  const applyMatterDefaults = async (matterId) => {
    if (!matterId) {
      formRenderPropsRef.current?.onChange?.("feeEarner", { value: null });
      formRenderPropsRef.current?.onChange?.("officeBank", { value: null });
      return;
    }

    try {
      const response = await api.getMatterDefaults(matterId);
      const defaults = response?.data?.data;
      if (!defaults) return;

      if (defaults.matterFeeEarner) {
        const matchedFeeEarner = activeFeeEarners.find(
          (fe) => String(fe?.userRef) === String(defaults?.matterFeeEarner),
        );
        formRenderPropsRef.current?.onChange?.("feeEarner", {
          value: matchedFeeEarner || null,
        });
      } else {
        formRenderPropsRef.current?.onChange?.("feeEarner", { value: null });
      }

      if (defaults.defaultOfficeBank) {
        const matchedOfficeBank = officeBankNominals.find(
          (n) => String(n?.nominalRef) === String(defaults?.defaultOfficeBank),
        );
        formRenderPropsRef.current?.onChange?.("officeBank", {
          value: {
            nominalRef: defaults.defaultOfficeBank,
            display:
              matchedOfficeBank?.display ?? String(defaults.defaultOfficeBank),
          },
        });
      } else {
        formRenderPropsRef.current?.onChange?.("officeBank", { value: null });
      }
    } catch (error) {
      console.error("Error applying matter defaults:", error);
    }
  };

  const getMatterData = async (matterId) => {
    if (matterId) {
      const datas = await api.getDisbursementMatterList(matterId);
      datas?.data?.data.forEach((element) => {
        element.inEdit = true;
        element.add = false;
        element.amount = 0;
      });
      setData(datas?.data?.data);
    } else {
      setData([]);
    }
  };

  const onChangematter = async (event) => {
    try {
      const nextMatterId = event?.value?.matterId;
      await getMatterData(nextMatterId);
      setmatterref(nextMatterId);
      await applyMatterDefaults(nextMatterId);
    } catch (error) {
      console.error(error);
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const reset = async () => {
    formRenderPropsRef.current?.onChange?.("feeEarner", { value: null });
    formRenderPropsRef.current?.onChange?.("officeBank", { value: null });
    setDetails("");
    setAmount(0);
    setPayee("");
    setReference("");
    setdateselector(new Date());
    setAllocation(null);
    setFilesData([]);
    setValidationAttempted(false);
    clearDisbursementFiles();
    await getMatterData(matterRef);
    await applyMatterDefaults(matterRef);
  };

  async function Submithandler(value) {
    if (
      matterRef == null ||
      matterRef === "" ||
      !payee?.trim() ||
      !reference?.trim() ||
      !details?.trim() ||
      !value?.officeBank ||
      !value?.feeEarner
    ) {
      setValidationAttempted(true);
      return;
    }

    const data = [
      {
        postingType: "DUP",
        reference: reference,
        matterID: matterRef,
        feeEarnerRef: value?.feeEarner?.userRef,
        date: dateselector,
        netAmount: amount,
        transactionPeriod: 202201,
        currencyCode: "GBP",
        details: details,
        reference: reference,
        Payee: payee,
        OfficeBank: value?.officeBank?.nominalRef,
      },
    ];

    if (allocation !== null) {
      data[0].allocations = allocation;
    }
    if (filesCurrentData[0] !== undefined) {
      const docsId = [];
      filesCurrentData.map((item) => {
        docsId.push(item.fileID);
      });
      data[0].DocumentFiles = docsId;
    }
    const totalAllocatedMinorUnits = (allocation || []).reduce(
      (sum, item) => sum + toCents(item.amount),
      0,
    );
    if (totalAllocatedMinorUnits !== toCents(amount)) {
      toast.error("Allocated amount should be equal to the Net amount");
      return;
    }
    setLoading(true);
    try {
      const response = await api.createposting(data);
      if (response?.status === 200) {
        toast.success("Posted successfully");
        setValidationAttempted(false);
        await reset();
      }
    } catch (error) {}
    setLoading(false);
  }

  const updateAllocations = useCallback((value) => {
    setAllocation(value);
  }, []);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      matterId: matterRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };

  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  return (
    <div className="h-100 pb-3 d-flex h-100 ps-0 ms-0 g-0">
      <div
        className="bgForm h-100 ms-2 pt-4 d-flex justify-content-center align-item-center"
        style={{
          minWidth: "350px",
          maxWidth: "350px",
          overflow: "auto",
        }}>
        <Form
          ignoreModified={true}
          onSubmit={Submithandler}
          initialValues={initialData}
          id="disbform"
          key={JSON.stringify(initialData)}
          render={(formRenderProps) => {
            formRenderPropsRef.current = formRenderProps;
            const officeBankValue = formRenderProps.valueGetter("officeBank");
            const feeEarnerValue = formRenderProps.valueGetter("feeEarner");

            return (
              <FormElement name="disbform" id="disbform">
                <fieldset>
                  <div className="mb-3">
                    <Label className="label">Matter</Label>
                    <div
                      className={
                        validationAttempted &&
                        (matterRef == null || matterRef === "")
                          ? "validation-invalid"
                          : ""
                      }
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <MattersCombobox
                        onChangematter={onChangematter}
                        reset={resetmatter}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <Label className="label">Date</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <DatePicker
                        className="datepicker px-2"
                        value={dateselector}
                        onChange={onChangedateselect}
                        toggleButton={CalenderCustomToggleButton}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <SearchComboBox
                      name="officeBank"
                      cbType={CONSTANT.OB}
                      controlled={true}
                      width="auto"
                      boxShadow={true}
                      error={validationAttempted && !officeBankValue}
                    />
                  </div>
                  <div className="mb-3">
                    <Label className="label">Reference</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <Input
                        width={200}
                        value={reference}
                        onChange={(e) => {
                          setReference(e.target.value);
                        }}
                        style={{
                          border:
                            validationAttempted && !reference?.trim()
                              ? "1px solid red"
                              : undefined,
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3 right-align">
                    <Label className="label">Amount</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <NumericTextBox
                        width={300}
                        style={{ textAlign: "right" }}
                        value={amount}
                        onChange={(e) => {
                          setAmount(e.target.value);
                        }}
                        placeholder="0.00"
                        spinners={false}
                        format="n2"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <SearchComboBox
                      name="feeEarner"
                      cbType={CONSTANT.FE}
                      controlled={true}
                      width="auto"
                      boxShadow={true}
                      error={validationAttempted && !feeEarnerValue}
                    />
                  </div>
                  <div className="mb-3">
                    <Label className="label">Payee</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <Input
                        width={200}
                        value={payee}
                        onChange={(e) => {
                          setPayee(e.target.value);
                        }}
                        style={{
                          border:
                            validationAttempted && !payee?.trim()
                              ? "1px solid red"
                              : undefined,
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <Label className="label">Details</Label>
                    <div
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
                      }}>
                      <TextArea
                        rows={4}
                        placeholder="Enter Details"
                        value={details}
                        onChange={(e) => {
                          setDetails(e.target.value);
                        }}
                        style={{
                          border:
                            validationAttempted && !details?.trim()
                              ? "1px solid red"
                              : undefined,
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <DocumentsUpload
                      progress={progress}
                      filesData={filesData}
                      onFileRemove={onFileRemove}
                      onError={() => {
                        const newFiles = filesData.splice(filesData.length, 1);
                        setFilesData([...newFiles]);
                      }}
                      onUpload={handleUpload}
                      type={"DUP"}
                    />
                  </div>
                  <button
                    id="submit-button"
                    type="button"
                    style={{ visibility: "hidden" }}
                    onClick={() => {
                      setValidationAttempted(true);
                      formRenderProps.onSubmit();
                    }}></button>
                </fieldset>
              </FormElement>
            );
          }}
        />
      </div>

      <div className="flex-grow-1 overflow-auto h-100 d-flex flex-column">
        <TransactionPeriod />

        <div
          className="mx-3 mt-3 h-100 d-flex flex-column"
          style={{ minHeight: "110px" }}>
          <DisbursementGrid
            Amount={amount}
            updateAllocations={updateAllocations}
            data={data}
          />

          <div className="buttonstyle justify-content-end">
            <Button
              form="disbform"
              className="common-btn"
              onClick={() => document.getElementById("submit-button").click()}
              type="button"
              disabled={loading}>
              Post
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DisbursementPayment;
